<template>
  <div class="user-panel">
    <DxDropDownButton
      v-if="menuMode !== 'list'"
      stylingMode="text"
      :showArrowIcon="false"
      :items="menuItems"
      displayExpr="text"
      keyExpr="id"
      :elementAttr="{
      class: 'user-button'
    }"
      :dropDownOptions="{
      width: '150px'
    }"
      template="dropDownButtonTemplate">
      <template #dropDownButtonTemplate>
        <div class="button-img-container">
          <img
            class="button-img"
            src="@/assets/profile.png"
            alt="employee">
        </div>
      </template>
    </DxDropDownButton>
    <DxList
      v-if="menuMode === 'list'"
      :items="menuItems"
      displayExpr="text"
      keyExpr="id"
      width="130"
    />
  </div>
</template>

<script setup>
import { DxDropDownButton, DxList } from 'devextreme-vue';
import { useAuthStore } from "@/stores/auth";
import { useRouter, useRoute } from 'vue-router';
import { useLocalization } from '@/locales/localization';

const auth = useAuthStore();
const router = useRouter();
const route = useRoute();
const localization = useLocalization();

var props = defineProps({
  menuMode: { type: String },
});


const menuItems = [
  {
    text: localization.t('general.profile'),
    icon: "user",
    onClick: onProfileClick
  },
  {
    text: localization.t('general.logout'),
    icon: "runner",
    onClick: onLogoutClick
  }
];

function onLogoutClick() {
  auth.logout();
  router.push({
    path: "/login",
    query: { redirect: route.path }
  });
}

function onProfileClick() {
  router.push('/administration/profile');
}
</script>

<style lang="scss">
.button-img-container {
  position: relative;
  height: 32px;
}

.button-img {
  width: 32px;
  height: 32px;
  position: relative;
  border-width: 1px;
  border-style: solid;
  border-color: var(--dx-color-border);
  border-radius: 50%;
}

.app .header-toolbar .user-panel .user-button.dx-dropdownbutton img.dx-icon {
  height: 100%;
  width: auto;

  .dx-theme-generic & {
    max-height: 32px;
  }
}

.user-panel  {
  display: flex;
  flex-direction: column;

  .user-button.dx-dropdownbutton {
    margin-left: 5px;

    img.dx-icon {
      border-radius: 50%;
      margin: 0;
      width: auto;
      aspect-ratio: 1 / 1;
      box-sizing: border-box;
      border: 1px solid var(--dx-color-border);
      object-fit: cover;
      object-position: top;
      background: rgb(255, 255, 255);
      background-clip: padding-box;
    }



    .dx-buttongroup {
      vertical-align: middle;

      .dx-button.dx-button-has-icon:not(.dx-button-has-text) {
        .dx-button-content {
          padding: 0;
        }

        &.dx-state-hover,
        &.dx-state-focused {
          background-color: transparent;

          img.dx-icon {
            border-color: var(--dx-color-primary);
          }
        }
      }
    }
  }
}
</style>
